import React, { useState } from "react";

// Components
import { Button, Form } from 'react-bulma-components';
import CurrencySelector from 'shared/components/company/currency/CurrencySelector';

//actions + utils
import { makeAPIRequest } from "shared/state/fetch";
import { useTokenStatus } from "shared/state/auth/actions";
import { convertObjNullToEmpty } from "shared/utils";

// Styles
import styles from './CompanyDetail.module.scss';

const CompanyDetail = ({ afterSave, company, onClose, viewOnly=false, withSelect=false }) => {
    const { Input, Field, Control, Label, Select } = Form;
    const { handleTokenStatus } = useTokenStatus();
    const normalizedCompany = company && convertObjNullToEmpty(company);
    const [updatedCompany, setUpdatedCompany] = useState(
        { ...normalizedCompany, currency_id: normalizedCompany.currency.id }
    );

    const handleSaveCompany = (e) => {
        e.preventDefault();

        makeAPIRequest(`companies/${company.id}`, 'PUT', updatedCompany)
            .then(response => {
                afterSave({ shouldFetch: true });
                response.status && handleTokenStatus(response);
            }
        )
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setUpdatedCompany(company);
        onClose();
    }

    const handleInputChange = (e) => {
        setUpdatedCompany(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }

    const handleCurrencySelect = (selected) => {
        setUpdatedCompany(prevState => ({
           ...prevState,
           currency: selected,
           currency_id: selected.id
        }));
    }

    return (
        <div className={ `${ viewOnly ? '' : styles.inner }` }>
            { !viewOnly &&
                <header className={ styles.header }>
                    <h2>{ updatedCompany.name }</h2>
                </header>
            }

            <div className={ styles.company }>
                <Field>
                    <Label>Company Name</Label>
                    <Control>
                        { withSelect ?
                            <Select
                                name="name"
                                onChange={ handleInputChange }
                                value={ updatedCompany.name }>
                                <option value="">
                                    - Choose a option -
                                </option>

                            </Select> :
                            <Input
                                onChange={ handleInputChange }
                                name="name"
                                readOnly={ viewOnly }
                                required
                                value={ updatedCompany.name }
                            />
                        }
                    </Control>
                </Field>
                <Field>
                    <Label>Business Sector</Label>
                    <Control>
                        <Input
                            onChange={ handleInputChange }
                            name="business_sector"
                            readOnly={ viewOnly }
                            value={ updatedCompany.business_sector }
                        />
                    </Control>
                </Field>
                <Field className={ styles.currency }>
                    <Label>Currency</Label>
                    <Control>
                        <CurrencySelector
                            //onChange={ handleInputChange }
                            currency={ updatedCompany.currency.code }
                            onSelect={ handleCurrencySelect }
                        />
                    </Control>
                </Field>
                <Field className={ styles.oneThird }>
                    <Label>Revenue</Label>
                    <Control>
                        <Input
                            onChange={ handleInputChange }
                            name="revenue"
                            readOnly={ viewOnly }
                            value={ updatedCompany.revenue }
                        />
                    </Control>
                </Field>
                <Field className={ styles.oneThird }>
                    <Label>Vat Number</Label>
                    <Control>
                        <Input
                            onChange={ handleInputChange }
                            name="vat_number"
                            readOnly={ viewOnly }
                            required
                            value={ updatedCompany.vat_number }
                        />
                    </Control>
                </Field>
            </div>

            { !viewOnly &&
            <section className="mt-3 pb-3">
                <h3>Company Location</h3>
                <div className={ styles.company }>
                    <Field>
                        <Label>City</Label>
                        <Control>
                            <Input
                                name="city"
                                onChange={ handleInputChange }
                                type="text"
                                value={ updatedCompany.city ? updatedCompany.city : '' }
                                />
                        </Control>
                    </Field>
                    <Field>
                        <Label>Zip code</Label>
                        <Control>
                            <Input
                                name="zip"
                                onChange={ handleInputChange }
                                type="text"
                                value={ updatedCompany.zip ? updatedCompany.zip : '' }
                                />
                        </Control>
                    </Field>
                    <Field>
                        <Label>Country</Label>
                        <Control>
                            <Input
                                name="country"
                                onChange={ handleInputChange }
                                type="text"
                                value={ updatedCompany.country ? updatedCompany.country : '' }
                                />
                        </Control>
                    </Field>
                </div>
            </section>
        }
        
        { !viewOnly &&
            <footer className={ styles.actions }>
                <Button onClick={ handleCancel }>
                    Cancel
                </Button>
                <Button
                    className={ styles.secondary }
                    onClick={ handleSaveCompany }>
                    Save Changes
                </Button>
            </footer>
        }
        </div>
    )
}

export default CompanyDetail;
